import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useAuth } from "@/auth/use-auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardBody, CardHeader } from "@/components/ui/card";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // If already signed in, jump to the dashboard.
  if (auth.state.status === "authenticated") {
    void navigate({ to: "/" });
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="flex-col items-center gap-3 border-b-0 px-6 pt-8 pb-4">
          <img
            src={`${import.meta.env.BASE_URL}brand/2oodles-logo-light.svg`}
            alt="2oodles"
            className="h-12 w-auto"
          />
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent">
            Just the 2 of us
          </p>
        </CardHeader>
        <CardBody>
          {submitted ? (
            <p className="text-sm text-zinc-700">
              If <span className="font-medium">{email}</span> is a superuser,
              we sent you a sign-in link. Click it on this device to land
              back here.
            </p>
          ) : (
            <form
              className="space-y-3"
              onSubmit={async (e) => {
                e.preventDefault();
                setError(null);
                setPending(true);
                try {
                  await auth.requestMagicLink(email.trim().toLowerCase());
                  setSubmitted(true);
                } catch (err) {
                  setError(err instanceof Error ? err.message : "request failed");
                } finally {
                  setPending(false);
                }
              }}
            >
              <label className="block text-sm font-medium">Email</label>
              <Input
                type="email"
                required
                autoFocus
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@2oodles.app"
              />
              {error && (
                <p className="text-sm text-red-600">{error}</p>
              )}
              <Button type="submit" disabled={pending} className="w-full">
                {pending ? "Sending…" : "Send admin sign-in link"}
              </Button>
              <p className="text-xs text-zinc-500">
                Magic-link only. Non-superusers cannot sign in here.
              </p>
            </form>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
